import LocalStorage from 'quasar/src/plugins/LocalStorage.js';

export function flush(state) {
  state.isQR = false;
}

export function bootComplete(state) {
  state.isBooting = false;
}

export function setAsQR(state) {
  state.isQR = true;
}

export function blockInteraction(state) {
  state.canInteract = false;
}
export function allowInteraction(state) {
  state.canInteract = true;
}

export function updateCurrentCategory(state, { category }) {
  state.currentCategory = category;
}

export function setValidAge(state) {
  state.validAge = true;
}

export function updateCurrentProduct(state, { product }) {
  state.currentProduct = product;
}

export function updateDefaultDeliveryMethod(state, { deliveryMethod }) {
  state.defaultDeliveryMethod = deliveryMethod;
}

export function setClosed(state) {
  state.closed = true;
}

export function setDistancingOrder(state, { order }) {
  state.distancingOrder = order;
}

export function updateLanguage(state, { language }) {
  state.language = language;
  LocalStorage.set('language', language);
}
